import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getProjectActivityEntriesSelector = createSelector(
  projectActivityEntries => projectActivityEntries.projectActivityEntries,
  (projectActivityEntriesById) => getArrayOfObjectValues(projectActivityEntriesById)
);